export const updateUrlSearchParams = (name: string, item?: string, search = location.search) => {
	const query = new URLSearchParams(search);
	if (item) query.set(name, item.toLowerCase());
	else query.delete(name);

	return query;
};
